import { render, staticRenderFns } from "./GruposVendas.vue?vue&type=template&id=b4d5039c&scoped=true&"
import script from "./GruposVendas.vue?vue&type=script&lang=js&"
export * from "./GruposVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d5039c",
  null
  
)

export default component.exports